// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"dac0kw","animatedgradient":"W6wsbr","button":"y7x_Xb","card":"YOpz18","divider":"Uj1RgG","perk":"HNsXdF","perksWrapper":"MYC8bU"};